var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSaver = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7526_3187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.75 28H5.25C2.35025 28 0 25.6497 0 22.75V5.25C0 2.35025 2.35025 0 5.25 0H22.75C25.6497 0 28 2.35025 28 5.25V22.75C28 25.6497 25.6497 28 22.75 28Z",
    fill: "#619BF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3698 10.8276C14.8516 10.8276 16.8635 9.97075 16.8635 8.91379C16.8635 7.85683 14.8516 7 12.3698 7C9.88796 7 7.87604 7.85683 7.87604 8.91379C7.87604 9.97075 9.88796 10.8276 12.3698 10.8276Z",
    fill: "#EBF3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7931 13.5453C12.1443 12.775 12.6717 12.1098 13.3227 11.602C13.0071 11.6299 12.6883 11.6488 12.3688 11.6488C10.6187 11.6488 8.85828 11.2296 7.875 10.4199V11.6488C7.87579 12.6225 9.58464 13.4247 11.7931 13.5453Z",
    fill: "#EBF3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3118 15.7502C11.3118 15.263 11.3816 14.7921 11.5037 14.3442C10.0581 14.2294 8.69578 13.8299 7.87585 13.1539V14.3828C7.87585 15.2884 9.35316 16.0447 11.3364 16.244C11.3213 16.0808 11.3118 15.9167 11.3118 15.7502Z",
    fill: "#EBF3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3344 11.3748C14.0023 11.3748 12.1055 13.3378 12.1055 15.7495C12.1055 18.1612 14.0023 20.125 16.3344 20.125C18.6665 20.125 20.5633 18.162 20.5633 15.7503C20.5633 13.3386 18.6657 11.3748 16.3344 11.3748ZM16.133 15.3401H16.535C17.1527 15.3401 17.6555 15.8602 17.6555 16.4992C17.6555 17.0743 17.255 17.5468 16.7301 17.6436V18.0742C16.7301 18.3007 16.5524 18.4844 16.3336 18.4844C16.1147 18.4844 15.9371 18.3007 15.9371 18.0742V17.6641H15.409C15.1901 17.6641 15.0125 17.4803 15.0125 17.2539C15.0125 17.0275 15.1901 16.8438 15.409 16.8438H16.535C16.7158 16.8438 16.8625 16.6912 16.8625 16.505C16.8625 16.313 16.715 16.1605 16.535 16.1605H16.133C15.5152 16.1605 15.0125 15.6404 15.0125 15.0014C15.0125 14.4263 15.4129 13.9538 15.9379 13.857V13.4264C15.9379 13.2 16.1155 13.0162 16.3344 13.0162C16.5532 13.0162 16.7309 13.2 16.7309 13.4264V13.8365H17.2598C17.4786 13.8365 17.6562 14.0203 17.6562 14.2467C17.6562 14.4731 17.4786 14.6568 17.2598 14.6568H16.1337C15.953 14.6568 15.8063 14.8094 15.8063 14.9956C15.8055 15.1876 15.953 15.3401 16.133 15.3401Z",
    fill: "#C2D8FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7526_3187"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSaver);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Saver.5a939253906ae151a2c10a1ea7285fbd.svg";